import React, { useState, useEffect } from 'react';
import './bye.css';
import ParticlesBg from 'particles-bg';
import FieldNote from '../../components/FieldNote';



function Bye(){
    const [particleCount, setParticleCount] = useState(100);

    useEffect(() => {
        const updateParticleCount = () => {
            setParticleCount(window.innerWidth <= 768 ? 26 : 100);
        };

        updateParticleCount();
        window.addEventListener('resize', updateParticleCount);
        return () => window.removeEventListener('resize', updateParticleCount);
    }, []);

    return(
        <div className="byes">
      <ParticlesBg type="cobweb" color="#ffffff" num={particleCount} />
      <div className="hero-content">
        <p className="hero-label">CUSTOMER SUCCESS · ACCOUNT LEADERSHIP · PRODUCT FLUENCY</p>
        <h1 className="name">I build the connections that turn customer relationships into lasting partnerships.</h1>
        <h5 className="bland">CS leader who scaled revenue 200%+ and grew accounts from 4 to 19 — with hands-on fluency in React, UX, and product development that helps me understand customers deeply, communicate clearly with technical teams, and turn ambiguity into action.</h5>
        <div className="hero-cta">
          <a href="#projects" className="btn-primary-hero">View My Work</a>
          <a href="#resume" className="btn-ghost-hero">Experience</a>
        </div>
      </div>
      <FieldNote />
 </div>

    )
}


export default Bye
